import { Component } from '@angular/core';
import { LoadingProvider } from "@providers/loading/loading";

@Component({
  selector: 'loading-gameif',
  templateUrl: 'loading.html'
})
export class LoadingComponent {

  public pending: number = 0;
  public _show: boolean = false;;

  constructor(private loadingProvider: LoadingProvider) {
    this.loadingProvider.loading.subscribe( (state: boolean) => {
      this._show = state;
      // if(x) {
      //   this.pending++;
      // } else {
      //   this.pending = this.pending > 0 ? this.pending - 1 : 0;
      // }
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/loading/loading.ts